import React from 'react';

import ModalHeader from '@components/modals/ModalHeader/ModalHeader';
import Button from '@components/uikit/Button/Button';

import useTranslation from '@hooks/useTranslation';

import { useModalActions } from '@store/useModalStore';

import style from './style.modules.scss';

const tagsRegs = {
  openBold: '<b>',
  closeBold: '</b>',
};

const NewActionItemTypesModal = () => {
  const { t } = useTranslation();
  const { setModalClose } = useModalActions();

  const handleClose = () => {
    setModalClose();
  };

  return (
    <div className={style.modalNewAiTypes}>
      <ModalHeader onClose={handleClose} />
      <div className={style.modalBody}>
        <div className={style.modalBodyTitle}>{t('Please note')}</div>
        <div className={style.modalBodyText}>
          <ul className={style.changesList}>
            <div className={style.changesListTitle}>
              {t('To increase clarity, we have updated the names of our action item types:')}
            </div>
            <li
              dangerouslySetInnerHTML={{
                __html: t(
                  '{openBold}Regular{closeBold} Action Items will now be called {openBold}Asset{closeBold} Action Items to better convey maintenance opportunities for your company’s assets.',
                  tagsRegs,
                ),
              }}
            />
            <li
              dangerouslySetInnerHTML={{
                __html: t(
                  '{openBold}Hardware{closeBold} Action Items will now be called {openBold}Network{closeBold} Action Items to better convey actions needed to maintain the Waites sensor network.',
                  tagsRegs,
                ),
              }}
            />
          </ul>
        </div>
      </div>
      <div className={style.modalFooter}>
        <Button type="primary" text={t('Close')} onClick={handleClose} />
      </div>
    </div>
  );
};

export default NewActionItemTypesModal;
